(() => {

  if (window.__ntiBelleCodAssetLoaded) return;

  window.__ntiBelleCodAssetLoaded = true;



  const WORKER_BASE = 'https://nti-belle-cod-api.aymanehachadi16.workers.dev';
  const WORKER_URL = WORKER_BASE + '/api/create-cod-order';





  let citiesPromise = null;
  const normalizeCity = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const getCities = () => {
    if (!citiesPromise) citiesPromise = fetch(WORKER_BASE + '/api/shipping-cities', { mode: 'cors' })
      .then(async response => { const data = await response.json(); if (!response.ok || !data.ok || !Array.isArray(data.cities)) throw Error('SHIPPING_UNAVAILABLE'); return data.cities; })
      .catch(error => { citiesPromise = null; throw error; });
    return citiesPromise;
  };
  const chosenCity = root => {
    const id = Number(root.querySelector('[data-district-id]')?.value);
    return root.__senditCities?.find(city => city.id === id && city.name === root.querySelector('[data-city-input]')?.value) || null;
  };
  const renderCityResults = root => {
    const input = root.querySelector('[data-city-input]');
    const list = root.querySelector('[data-city-results]');
    if (!input || !list) return;
    const query = normalizeCity(input.value);
    const matches = (root.__senditCities || []).filter(city => !query || normalizeCity(city.name).includes(query) || normalizeCity(city.arabic_name).includes(query)).slice(0, 25);
    list.replaceChildren();
    for (const city of matches) {
      const button = document.createElement('button'); button.type = 'button'; button.setAttribute('role', 'option');
      const name = document.createElement('span'); name.textContent = city.name;
      const price = document.createElement('small'); price.textContent = `${city.price} DH`;
      button.append(name, price);
      button.addEventListener('click', () => {
        input.value = city.name;
        root.querySelector('[data-district-id]').value = String(city.id);
        list.hidden = true; input.setAttribute('aria-expanded', 'false');
        hideError(root); sync(root);
      });
      list.append(button);
    }
    if (!matches.length) {
      const empty = document.createElement('div'); empty.className = 'nti-cod__city-empty';
      empty.textContent = root.dataset.lang === 'ar' ? 'لم يتم العثور على مدينة' : 'Aucune ville trouvée'; list.append(empty);
    }
    list.hidden = false; input.setAttribute('aria-expanded', 'true');
  };
  const loadCities = async root => {
    const shipping = root.querySelector('[data-shipping]');
    if (shipping && !chosenCity(root)) shipping.textContent = '…';
    try { root.__senditCities = await getCities(); if (!chosenCity(root)) { if (shipping) shipping.textContent = '—'; } }
    catch (_) { if (shipping) shipping.textContent = '—'; showError(root, root.dataset.lang === 'ar' ? 'تعذر تحميل مدن التوصيل. حاولي مجدداً.' : 'Impossible de charger les villes. Réessayez.'); }
    sync(root);
  };

  /*

   * Product variants

   */

  const getVariants = (root) => {

    try {

      return JSON.parse(

        root.querySelector(

          '[data-variants]'

        )?.textContent || '[]'

      );

    } catch (_) {

      return [];

    }

  };



  /*

   * Currently selected Shopify variant

   */

  const getSelectedVariant = (

    root,

    variants

  ) => {

    const productInfo =

      root.closest(

        '.product-information'

      );



    const productForm =

      productInfo?.querySelector(

        'form[action*="/cart/add"]'

      ) ||

      document.querySelector(

        'form[action*="/cart/add"]'

      );



    let id = 0;



    if (productForm) {

      try { id = Number(new FormData(productForm).get('id') || 0); } catch (_) {}

      if (!id) id = Number(productForm.querySelector('[name="id"]')?.value || 0);

    }



    // Do not silently submit the first colour when Shopify has not yet

    // exposed the currently selected variant ID.

    const selected = variants.find((x) => Number(x.id) === id);

    if (selected) return selected;



    return variants.length === 1 ? variants[0] : null;

  };



  /*

   * Quantity

   */

  const qty = (root) => {

    const input =

      root.querySelector(

        '[data-qty]'

      );



    return Math.max(

      1,

      Math.min(

        root.dataset.upsellMode === 'cosmetic' ? 3 : 10,

        parseInt(

          input?.value || '1',

          10

        ) || 1

      )

    );

  };



  /*

   * Money formatting

   */

  const money = (

    root,

    cents

  ) => {

    try {

      return new Intl.NumberFormat(

        root.dataset.lang === 'ar'

          ? 'ar-MA'

          : 'fr-MA',

        {

          style: 'currency',

          currency:

            root.dataset.currency ||

            'MAD',

          minimumFractionDigits: 2

        }

      ).format(

        (Number(cents) || 0) /

          100

      );

    } catch (_) {

      return (

        (

          (Number(cents) || 0) /

          100

        ).toFixed(2) +

        ' dh'

      );

    }

  };



  /*

   * Sync product / quantity / totals

   */

  // Shopify automatic related products, fetched once when modal opens.
  const isCosmetic = root => root.dataset.upsellMode === 'cosmetic';
  const selectedUpsells = root => [...root.querySelectorAll('[data-upsell-button][aria-pressed="true"]')]
    .sort((a, b) => Number(a.dataset.selectionOrder || 0) - Number(b.dataset.selectionOrder || 0))
    .map(button => ({ variantId: String(button.dataset.variantId), quantity: 1, price: Number(button.dataset.price || 0) }));

  const upsellDiscountCents = root => {
    if (isCosmetic(root)) {
      const variant = getSelectedVariant(root, getVariants(root));
      const price = Number(variant?.price || 0);
      return (qty(root) >= 2 ? Math.round(price * 0.15) : 0) +
        (qty(root) >= 3 ? Math.round(price * 0.30) : 0);
    }
    return selectedUpsells(root).reduce((sum, item) => sum + Math.round(item.price * 0.10), 0);
  };

  const refreshUpsellLabels = root => {
    const chosen = [...root.querySelectorAll('[data-upsell-button][aria-pressed="true"]')]
      .sort((a,b) => Number(a.dataset.selectionOrder || 0) - Number(b.dataset.selectionOrder || 0));
    root.querySelectorAll('[data-upsell-button]').forEach(button => {
      const rank = chosen.indexOf(button);
      const rate = isCosmetic(root) ? (rank === 1 ? 0.30 : 0.15) : 0.10;
      const price = Number(button.dataset.price || 0);
      const label = button.closest('.nti-cod__upsell-item')?.querySelector('small');
      if (label) label.textContent = money(root, price - Math.round(price * rate)) + ` (−${Math.round(rate * 100)}%)`;
    });
  };

  // Round down to the nearest price ending in 0, 5, or 9 MAD.
  // All amounts are integer cents; shipping is included before rounding.
  const roundingDiscountCents = (totalCents) => {
    // Work in cents and round the FINAL payable amount, after upsell discount.
    // Accepted whole-MAD endings: 0, 5, 9. Never round upwards.
    const wholeDh = Math.floor(totalCents / 100);
    const digit = wholeDh % 10;
    const targetDh = wholeDh - (digit <= 4 ? digit : digit <= 8 ? digit - 5 : 0);
    return totalCents - targetDh * 100;
  };

  const loadUpsells = async (root) => {
    if (isCosmetic(root)) {
      root.querySelector('[data-upsell-section]')?.removeAttribute('hidden');
      return;
    }
    if (root.dataset.upsellLoaded) return;
    root.dataset.upsellLoaded = '1';
    const productId = root.dataset.productId;
    if (!/^\d+$/.test(productId || '')) return;
    try {
      // Only wallets/accessories. Never display handbags in cross-sell.
      // Set actual Shopify collection handles in data-upsell-collections on the Liquid root.
      const handles = (root.dataset.upsellCollections || 'portefeuilles,accessoires')
        .split(',').map(x => x.trim()).filter(x => /^[a-z0-9-]+$/.test(x));
      const eligible = p => {
        const haystack = [p.product_type, ...(p.tags || []), p.handle, p.title].join(' ').toLowerCase();
        const accessory = /portefeuille|wallet|porte.monnaie|bijou|bracelet|collier|bague|boucle|accessoire|cheveux|hair|pince|barrette/.test(haystack);
        const bag = /(^|[^a-z])(sac|handbag|bag|pochette)([^a-z]|$)/.test(haystack);
        return isCosmetic(root) ? true : (accessory && !bag);
      };
      const pool = [];
      for (const handle of handles) {
        try {
          const response = await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=30`, { credentials: 'same-origin' });
          if (!response.ok) continue;
          const data = await response.json();
          pool.push(...(data.products || []));
        } catch (err) { console.warn('[NTI COD collection]', handle, err); }
      }
      const seen = new Set();
      const candidates = pool.filter(p => String(p.id) !== productId && eligible(p) && !seen.has(String(p.id)) && seen.add(String(p.id)))
        .map(p => ({ p, v: (p.variants || []).length === 1 ? (p.variants[0].available && Number(p.variants[0].price) > 0 ? p.variants[0] : null) : null }))
        .filter(x => x.v).slice(0, 2);
      if (!candidates.length) return;
      const list = root.querySelector('[data-upsell-list]');
      if (!list) return;
      list.replaceChildren();
      for (const {p, v} of candidates) {
        const upsellPriceCents = Math.round(Number(v.price) * 100);
        const item = document.createElement('div'); item.className = 'nti-cod__upsell-item';
        const img = document.createElement('img'); img.loading = 'lazy';
        img.alt = p.title || '';
         const imageData = p.featured_image || p.images?.[0];
         const imageUrl = typeof imageData === 'string' ? imageData : (imageData?.src || '');
         if (imageUrl) img.src = imageUrl.replace(/^\/\//, 'https://');
        const detail = document.createElement('div');
        const title = document.createElement('strong'); title.textContent = p.title || '';
        const price = document.createElement('small'); price.textContent = money(root, upsellPriceCents - Math.round(upsellPriceCents * (isCosmetic(root) ? 0.15 : 0.10))) + (isCosmetic(root) ? ' (−15%)' : ' (−10%)');
        detail.append(title, price);
        const button = document.createElement('button'); button.type = 'button';
        button.dataset.upsellButton = ''; button.dataset.variantId = String(v.id);
        button.dataset.price = String(upsellPriceCents); button.setAttribute('aria-pressed', 'false');
        button.textContent = root.dataset.lang === 'ar' ? '+ إضافة' : '+ Ajouter';
        item.append(img, detail, button); list.append(item);
      }
      root.querySelector('[data-upsell-section]').hidden = false;
    } catch (err) { console.warn('[NTI COD upsell]', err); }
  };

  const sync = (root) => {

    const variants =

      getVariants(root);



    const variant =

      getSelectedVariant(

        root,

        variants

      );



    if (!variant) return;



    const n = qty(root);



    const q =

      root.querySelector(

        '[data-qty]'

      );



    if (q) {

      q.value = n;

    }



    const bubble =

      root.querySelector(

        '[data-qbubble]'

      );



    if (bubble) {

      bubble.textContent = n;

    }



    const unit =

      root.querySelector(

        '[data-unit]'

      );



    if (unit) {

      unit.textContent =

        money(

          root,

          variant.price

        );

    }



    const subtotal =

      root.querySelector(

        '[data-sub]'

      );



    if (subtotal) {

      subtotal.textContent =

        money(

          root,

          variant.price * n + (isCosmetic(root) ? 0 : selectedUpsells(root).reduce((sum, item) => sum + item.price, 0))

        );

    }



    /*

     * Livraison dynamique Sendit.

     */

    const total =

      root.querySelector(

        '[data-total]'

      );



    const selectedShipping = chosenCity(root);
    const shippingLabel = root.querySelector('[data-shipping]');
    if (shippingLabel) shippingLabel.textContent = selectedShipping
      ? money(root, Math.round(selectedShipping.price * 100)) : '—';

    // Only reveal Offre Duo once the customer adds a cross-sell item.
    // This is independent of whether the delivery city has been selected.
    if (isCosmetic(root)) {
      root.querySelectorAll('[data-bundle-qty]').forEach(button => {
        const active = Number(button.dataset.bundleQty) === n;
        button.setAttribute('aria-pressed', String(active));
      });
      const label = root.querySelector('[data-bundle-discount-label]');
      if (label) label.textContent = n === 3 ? 'Offre Trio · −15% + −30%' : 'Offre Duo · −15% sur le 2ème pack';
      const duo = root.querySelector('[data-bundle-duo-price]');
      const trio = root.querySelector('[data-bundle-trio-price]');
      if (duo) duo.textContent = money(root, variant.price * 2 - Math.round(variant.price * .15));
      if (trio) trio.textContent = money(root, variant.price * 3 - Math.round(variant.price * .15) - Math.round(variant.price * .30));
    }
    const upsellDiscount = upsellDiscountCents(root);
    const upsellDiscountEl = root.querySelector('[data-upsell-discount]');
    const upsellDiscountRow = root.querySelector('[data-upsell-discount-row]');
    if (upsellDiscountEl) upsellDiscountEl.textContent = '- ' + money(root, upsellDiscount);
    if (upsellDiscountRow) {
      upsellDiscountRow.hidden = upsellDiscount <= 0;
      upsellDiscountRow.style.display = upsellDiscount > 0 ? 'flex' : 'none';
    }

    const discountEl = root.querySelector('[data-rounding-discount]');
    const discountRow = root.querySelector('[data-rounding-row]');
    if (!selectedShipping) {
      if (total) total.textContent = '—';
      if (discountRow) { discountRow.hidden = true; discountRow.style.display = 'none'; }
    } else {
      const itemsSubtotal = variant.price * n + (isCosmetic(root) ? 0 : selectedUpsells(root).reduce((sum, item) => sum + item.price, 0));
      const gross = itemsSubtotal + Math.round(selectedShipping.price * 100) - upsellDiscount;
      const discount = roundingDiscountCents(gross);
      if (discountEl) discountEl.textContent = '- ' + money(root, discount);
      if (discountRow) {
        discountRow.hidden = discount <= 0;
        discountRow.style.display = discount > 0 ? 'flex' : 'none';
      }
      if (total) total.textContent = money(root, gross - discount);
    }


    const title =

      root.querySelector(

        '[data-vtitle]'

      );



    if (title) {

      title.textContent =

        variant.title ===

        'Default Title'

          ? ''

          : variant.title;

    }



    const image =

      root.querySelector(

        '[data-cod-image]'

      );



    if (

      image &&

      variant.image

    ) {

      image.src = variant.image;

      image.removeAttribute('srcset');

    }



    const open =

      root.querySelector(

        '[data-open]'

      );



    if (open) {

      open.disabled =

        !variant.available;



      open.textContent =

        variant.available

          ? (

              root.dataset.lang ===

              'ar'

                ? 'اشتري الآن'

                : 'Acheter maintenant'

            )

          : (

              root.dataset.lang ===

              'ar'

                ? 'غير متوفر'

                : 'Indisponible'

            );

    }

  };





  /*

   * Errors

   */

  const showError = (

    root,

    message

  ) => {

    const error =

      root.querySelector(

        '[data-error]'

      );



    if (!error) return;



    error.textContent =

      message;



    error.hidden = false;

  };



  const hideError = (root) => {

    const error =

      root.querySelector(

        '[data-error]'

      );



    if (!error) return;



    error.hidden = true;

    error.textContent = '';

  };



  /*

   * Restore Commander button

   */

  const restoreCommander = (

    commander,

    ar

  ) => {

    commander.disabled =

      false;



    commander.textContent =

      ar

        ? 'تأكيد الطلب'

        : 'Commander';

  };



  /*

   * Main events

   */

  document.addEventListener(

    'click',

    async (event) => {



      /*

       * OPEN MODAL

       */

      const open =

        event.target.closest(

          '.nti-cod [data-open]'

        );



      if (open) {

        const root =

          open.closest(

            '.nti-cod'

          );



        sync(root);
        loadUpsells(root);
        loadCities(root);

        hideError(root);



        const overlay =

          root.querySelector(

            '[data-overlay]'

          );



        if (overlay) {

          overlay.hidden =

            false;

        }



        document

          .documentElement

          .classList.add(

            'nti-cod-open'

          );

return;

      }



      /*

       * CLOSE MODAL

       */

      const close =

        event.target.closest(

          '.nti-cod [data-close]'

        );



      if (close) {

        const root =

          close.closest(

            '.nti-cod'

          );



        const overlay =

          root.querySelector(

            '[data-overlay]'

          );



        if (overlay) {

          overlay.hidden =

            true;

        }



        document

          .documentElement

          .classList.remove(

            'nti-cod-open'

          );



        return;

      }



      /*

       * QUANTITY - / +

       */

      const minus =

        event.target.closest(

          '.nti-cod [data-minus]'

        );



      const plus =

        event.target.closest(

          '.nti-cod [data-plus]'

        );



      if (minus || plus) {

        const root =

          (

            minus ||

            plus

          ).closest(

            '.nti-cod'

          );



        const input =

          root.querySelector(

            '[data-qty]'

          );



        if (input) {

          input.value =

            minus

              ? Math.max(

                  1,

                  qty(root) - 1

                )

              : Math.min(

                  isCosmetic(root) ? 3 : 10,

                  qty(root) + 1

                );

        }



        sync(root);



        return;

      }





      const bundleButton = event.target.closest('.nti-cod [data-bundle-qty]');
      if (bundleButton) {
        const root = bundleButton.closest('.nti-cod');
        const input = root.querySelector('[data-qty]');
        if (input) input.value = bundleButton.getAttribute('aria-pressed') === 'true' ? '1' : bundleButton.dataset.bundleQty;
        sync(root);
        return;
      }
      const upsellButton = event.target.closest('.nti-cod [data-upsell-button]');
      if (upsellButton) {
        const root = upsellButton.closest('.nti-cod');
        const active = upsellButton.getAttribute('aria-pressed') === 'true';
        if (!active) {
          root.__upsellSequence = (root.__upsellSequence || 0) + 1;
          upsellButton.dataset.selectionOrder = String(root.__upsellSequence);
        } else {
          delete upsellButton.dataset.selectionOrder;
        }
        upsellButton.setAttribute('aria-pressed', String(!active));
        refreshUpsellLabels(root);
        upsellButton.textContent = !active
          ? (root.dataset.lang === 'ar' ? '✓ تمت الإضافة' : '✓ Ajouté')
          : (root.dataset.lang === 'ar' ? '+ إضافة' : '+ Ajouter');
        sync(root);
        return;
      }

      /* COMMANDER */

      const commander =

        event.target.closest(

          '.nti-cod [data-commander]'

        );



      if (!commander) {

        return;

      }



      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();



      /*

       * Prevent double click.

       */

      if (

        commander.disabled

      ) {

        return;

      }



      const root =

        commander.closest(

          '.nti-cod'

        );



      const variants =

        getVariants(root);



      const variant =

        getSelectedVariant(

          root,

          variants

        );



      const n =

        qty(root);



      const ar =

        root.dataset.lang ===

        'ar';



      const name =

        String(

          root.querySelector(

            '[name="name"]'

          )?.value || ''

        ).trim();



      const phone =

        String(

          root.querySelector(

            '[name="phone"]'

          )?.value || ''

        ).trim();



      const address =

        String(

          root.querySelector(

            '[name="address"]'

          )?.value || ''

        ).trim();



      const shippingCity = chosenCity(root);
      const city = shippingCity?.name || '';
      const districtId = shippingCity?.id;
      const addressExtra = ''; // Single address field; optional extra field removed

      /*

       * Form validation

       */

      if (

        !name ||

        !phone ||

        !address ||

        !city

      ) {

        showError(

          root,

          ar

            ? 'المرجو ملء جميع المعلومات المطلوبة.'

            : 'Veuillez remplir toutes les informations.'

        );



        return;

      }



      if (address.length < 8 || !districtId) {
        showError(root, ar ? 'المرجو اختيار المدينة من اللائحة وكتابة عنوان واضح.' : 'Choisissez une ville dans la liste et saisissez une adresse complète.');
        return;
      }

      const phoneDigits =

        phone.replace(

          /\D/g,

          ''

        );



      if (

        phoneDigits.length <

          9 ||

        phoneDigits.length >

          15

      ) {

        showError(

          root,

          ar

            ? 'المرجو إدخال رقم هاتف صحيح.'

            : 'Veuillez saisir un numéro valide.'

        );



        return;

      }



      if (

        !variant ||

        !variant.available

      ) {

        showError(

          root,

          ar

            ? 'هذا المنتج غير متوفر حالياً.'

            : 'Ce produit est actuellement indisponible.'

        );



        return;

      }



      hideError(root);



      /*

       * Lock Commander

       */

      commander.disabled =

        true;



      commander.textContent =

        ar

          ? 'جارٍ تأكيد الطلب…'

          : 'Confirmation de la commande…';



      try {

        /*

         * Send directly to Worker.

         *

         * NO CART.

         * NO CHECKOUT.

         */

        const response =

          await fetch(

            WORKER_URL,

            {

              method: 'POST',



              headers: {

                'Content-Type':

                  'application/json'

              },



              body:

                JSON.stringify({

                  variantId:

                    String(

                      variant.id

                    ),



                  quantity: n,
                  items: [{ variantId: String(variant.id), quantity: n }, ...(isCosmetic(root) ? [] : selectedUpsells(root).map(({ variantId, quantity }) => ({ variantId, quantity })))],



                  name,

                  phone,

                  address,
                  addressExtra,
                  districtId,

                  city

})

            }

          );



        let result = null;



        try {

          result =

            await response.json();

        } catch (_) {

          throw new Error(

            'INVALID_SERVER_RESPONSE'

          );

        }



        /*

         * Worker / Shopify error

         */

        if (

          !response.ok ||

          !result?.ok

        ) {

          console.error(

            '[Nti Belle COD] Worker response:',

            result

          );



          let message =

            ar

              ? 'تعذر تسجيل الطلب. المرجو المحاولة مرة أخرى.'

              : 'Impossible d’enregistrer la commande. Veuillez réessayer.';



          if (['INVALID_DELIVERY_CITY', 'SHIPPING_UNAVAILABLE'].includes(result?.error)) {
            message = ar ? 'تعذر التحقق من مدينة التوصيل. حاولي مجدداً.' : 'Ville ou tarif de livraison indisponible. Réessayez.';
          }
          if (

            result?.error ===

            'INVALID_PHONE'

          ) {

            message =

              ar

                ? 'المرجو إدخال رقم هاتف صحيح.'

                : 'Veuillez saisir un numéro valide.';

          }



          if (

            result?.error ===

            'MISSING_OR_INVALID_FIELDS'

          ) {

            message =

              ar

                ? 'المرجو التأكد من جميع المعلومات.'

                : 'Veuillez vérifier toutes les informations.';

          }

if (

            result?.error ===

            'TOO_MANY_ORDERS'

          ) {

            message =

              ar

                ? 'Trop de tentatives. Reessayez dans quelques secondes.'

                : 'Trop de tentatives. Réessayez dans quelques secondes.';

          }



          showError(

            root,

            message

          );



          restoreCommander(

            commander,

            ar

          );



          return;

        }



        /*

         * ORDER CREATED

         */

        console.log(

          '[Nti Belle COD] Order created:',

          result.orderName

        );



        commander.textContent =

          ar

            ? 'تم تأكيد الطلب ✓'

            : 'Commande confirmée ✓';



        /*

         * Save temporary order data

         * for /pages/merci.

         *

         * No personal information

         * is placed in the URL.

         */

        try {

          sessionStorage.setItem(

            'ntiBelleLastOrder',

            JSON.stringify({

              orderName:

                result.orderName ||

                '',



              name,

              phone,

              address,

              city,



              product:

                root.dataset.title ||

                '',



              variant:

                variant.title ===

                'Default Title'

                  ? ''

                  : variant.title,



              quantity: n,



              total:

                result.total ||

                (

                  (

                    Number(

                      variant.price

                    ) || 0

                  ) *

                    n /

                  100

                ).toFixed(2),



              currency:

                result.currency ||

                root.dataset

                  .currency ||

                'MAD',



              payment:

                'Cash on Delivery (COD)',



              shipping:

                `${result.shipping ?? shippingCity.price} DH`,



            })

          );

        } catch (err) {

          console.warn(

            '[Nti Belle COD] sessionStorage:',

            err

          );

        }



        /*

         * Redirect to Thank You page

         */

        const redirect =

          result.redirect ||

          '/pages/merci';



        const destination =

          new URL(

            redirect,

            window.location

              .origin

          );



        if (

          result.orderName

        ) {

          destination

            .searchParams

            .set(

              'order',

              result.orderName

            );

        }



        window.location.assign(

          destination.toString()

        );

      } catch (err) {

        console.error(

          '[Nti Belle COD]',

          err

        );

showError(

          root,

          ar

            ? 'وقع خطأ في الاتصال. المرجو المحاولة مرة أخرى.'

            : 'Une erreur de connexion est survenue. Veuillez réessayer.'

        );



        restoreCommander(

          commander,

          ar

        );

      }

    },

    true

  );



  /*

   * Close when clicking overlay

   */

  document.addEventListener(

    'click',

    (event) => {

      const overlay =

        event.target.closest(

          '.nti-cod [data-overlay]'

        );



      if (

        overlay &&

        event.target === overlay

      ) {

        overlay.hidden =

          true;



        document

          .documentElement

          .classList.remove(

            'nti-cod-open'

          );

      }

    }

  );





  document.addEventListener('input', event => {
    if (!event.target.matches('.nti-cod [data-city-input]')) return;
    const root = event.target.closest('.nti-cod');
    root.querySelector('[data-district-id]').value = '';
    renderCityResults(root); sync(root);
  });
  document.addEventListener('focusin', event => {
    if (!event.target.matches('.nti-cod [data-city-input]')) return;
    const root = event.target.closest('.nti-cod');
    if (root.__senditCities) renderCityResults(root);
    else loadCities(root).then(() => renderCityResults(root));
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.nti-cod').forEach(root => {
      if (event.target.closest('[data-city-input], [data-city-results]')?.closest('.nti-cod') === root) return;
      const list = root.querySelector('[data-city-results]'); if (list) list.hidden = true;
    });
  });

  /*

   * Manual quantity input

   */

  document.addEventListener(

    'input',

    (event) => {

      if (

        !event.target.matches(

          '.nti-cod [data-qty]'

        )

      ) {

        return;

      }



      const root =

        event.target.closest(

          '.nti-cod'

        );



      sync(root);

    }

  );



  /*

   * Shopify variant change

   */

  document.addEventListener(

    'change',

    () => {

      document

        .querySelectorAll(

          '.nti-cod'

        )

        .forEach((root) => {

          sync(root);

            });

    }

  );



  /*

   * Initial sync

   */

  document

    .querySelectorAll(

      '.nti-cod'

    )

    .forEach(sync);

})();